// console.log('got to registrations javascript');

import exportCSVFile from '../scripts/csv';

$(function() {
  // $("input[name='athlete_options']").on('change', function(event) {

  //   const currentAthlete = event.target.id === 'current-athlete'

  //   $('label').removeClass('bg-fanword-yellow');

  //   $(`label[for="${event.target.id}"]`).addClass('bg-fanword-yellow');

  //   if (currentAthlete) {
  //     $("#registration-form").removeClass('d-none').addClass('d-block');
  //     $("#non-athlete-form").removeClass('d-block').addClass('d-none');
  //   } else {
  //     $("#registration-form").removeClass('d-block').addClass('d-none');
  //     $("#non-athlete-form").removeClass('d-none').addClass('d-block');
  //   }
  // });

  const searchParams = new URLSearchParams(window.location.search);
  if (!!searchParams.get('current_athlete') ) {
    $("input#current-athlete").trigger('click')
  }

  if (searchParams.get('current_athlete') && !searchParams.get('current_athlete')) {
    $("input#non-athlete").trigger('click')
  }

  $("#export-newsletter-emails").on('click', function(event) {
    event.preventDefault();

    // headers
    const headers = [
      'email',
      'date_captured'
    ];

    // data
    const data = [];
    const rows = document.querySelector("#newsletter-email-table").querySelectorAll('tr');
    rows.forEach(row => {
      const cells = row.querySelectorAll('td');
      const datum = {
        email: cells[0].innerText,
        date_captured: cells[1].innerText
      }

      data.push(datum);
    })

    // file name
    const fileName = "athletes_newsletter_emails";

    exportCSVFile(headers, data, fileName);
  })

})
